import { SvgIcon, Typography, styled } from "@mui/material"

import { ReactComponent as DocIcon } from "./Document.svg"

const LARGE_SIZE = 80
const NORMAL_SIZE = 40

const DocumentIcon = (props) => {
    return (
        <SvgIcon component={DocIcon} {...props} inheritViewBox />
    )
}

export const IconWrapper = styled("div", { shouldForwardProp: (prop) => prop !== "variant" })(({ variant }) => ({
    position: "relative",
    width: variant === "large" ? LARGE_SIZE : NORMAL_SIZE,
    height: variant === "large" ? LARGE_SIZE : NORMAL_SIZE,
}))

export const Icon = styled(DocumentIcon)(({ theme }) => ({
    width: "100%",
    height: "100%",
    color: theme.palette.primary.light,
}))

export const Badge = styled("div", { shouldForwardProp: (prop) => prop !== "variant" })(({ theme, variant }) => ({
    position: "absolute",
    bottom: variant === "large" ? 14 : 7,
    left: variant === "large" ? 4 : 2,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: 4,
    padding: variant === "large" ? "6px 4px" : "3px 2px",
    width: "fit-content",
    height: "fit-content",
}))

export const ExtensionText = styled(Typography, { shouldForwardProp: (prop) => prop !== "variant" })(({ theme, variant }) => ({
    color: theme.palette.common.white,
    fontFamily: "Poppins",
    fontSize: variant === "large" ? 20 : 8,
    fontStyle: "normal",
    fontWeight: 700,
    textTransform: "uppercase",
    lineHeight: 1,
}))